<template>
  <div class="main" v-if="basicInfo">
    <div class="withdraw">
      <withdraw-detail :amount="basicInfo.Amount" @checkDetail="checkDetail"> </withdraw-detail>
      <!-- 增加展现【待扣金额】模块 -->
      <div class="waitingForPayModel" v-if="basicInfo.WaitDeductAmount">
        <div class="infoPart">
          <div class="tip">你有一笔待扣金额需要支付</div>
          <div class="price">
            <span class="symbol">￥</span>
            <span>{{ basicInfo.WaitDeductAmount.toFixed(2) }}</span>
          </div>
        </div>
        <div class="controlPart">
          <div class="btn tapActive" @click="$router.push('waitingForPayDetail')">
            查看详情
          </div>
          <div class="btn tapActive mainBtn" @click="showPayMode = true">
            立即支付
          </div>
        </div>
      </div>
      <div class="withdraw-type-box">
        <div class="title">提现方式</div>
        <!-- 银行卡异常提示 -->
        <div class="withdraw-type-error" v-if="withdrawType === 2 && bankCardIsError">
          <i class="iconfont icon-warn1"></i>
          <span>你绑定的银行卡与持卡人信息不一致，请修改</span>
        </div>
        <div class="radio-type-group">
          <!-- 微信 -->
          <div class="radio-type-item" v-if="basicInfo.IsWechatAvailable && !basicInfo.IsWxTALimit">
            <label class="radio-select-lable">
              <input type="radio" class="radio-input" name="withdrawRadio" :value="0" v-model="withdrawType" />
              <span class="radio-core"></span>
            </label>
            <div class="radio-item-detail" @click="radioItemClick(0)">
              <i class="iconfont icon-weixin1 wx"></i>
              <div>微信提现</div>
            </div>
          </div>
          <!-- 支付宝 -->
          <div class="radio-type-item card-item" v-if="zfbWithdrawalStatus.isAlipayAvailable">
            <div class="card-radio-box">
              <label class="radio-select-lable">
                <input type="radio" class="radio-input" name="withdrawRadio" :value="1" v-model="withdrawType" />
                <span class="radio-core"></span>
              </label>
              <div class="radio-item-detail" :class="{ noborder: withdrawType === 1 }" @click="radioItemClick(1)">
                <i class="iconfont icon-zhifubao zfb"></i>
                <div>支付宝提现</div>
              </div>
            </div>
            <div class="card-detail-box" v-if="withdrawType === 1">
              <!-- 修改支付宝账号信息 -->
              <div v-if="basicInfo.IsBindAlipay" class="bindZFBInfo">
                <div class="leftPart">
                  <div class="logo">
                    <span class="iconfont icon-zhifubao"></span>
                  </div>
                  <div class="accountInfo">
                    <div class="account">
                      {{ $utils.stringModify(basicInfo.AlipayNo, 11) }}
                    </div>
                    <div class="accountName">({{ basicInfo.AlipayName | formatName }})</div>
                  </div>
                </div>
                <div class="modifyBtn tapActive" @click="modifyZFB(1)">
                  修改
                </div>
              </div>
              <!-- add -->
              <div v-else class="card-detail-box tapActive" @click="modifyZFB">
                <div class="add-card">
                  <i class="iconfont icon-close"></i>
                  <span>添加支付宝</span>
                </div>
              </div>
            </div>
          </div>
          <!-- 银行卡 -->
          <div class="radio-type-item card-item" v-if="bankWithdrawalStatus">
            <div class="card-radio-box">
              <label class="radio-select-lable">
                <input type="radio" class="radio-input" name="withdrawRadio" :value="2" v-model="withdrawType" />
                <span class="radio-core"></span>
              </label>
              <div class="radio-item-detail" :class="{ noborder: withdrawType === 2 }" @click="radioItemClick(2)">
                <i class="iconfont icon-xinyongqia1 card"></i>
                <div>
                  <p>银行卡提现</p>
                  <p class="t_999 oneRow fs_13">
                    <!-- 单笔提现金额需 ≥ {{ basicInfo.BankMinMoney }} 元 -->
                    每笔提现手续费{{ basicInfo.BankPoundageRate * 100 }}%，手续费最低{{ basicInfo.BankMinPoundage }}元
                  </p>
                </div>
              </div>
            </div>
            <div class="card-detail-box" v-if="withdrawType === 2">
              <!-- card -->
              <div class="card-info" v-if="basicInfo.IsBankAdd">
                <div class="c-info">
                  <van-image round fit="contain" class="logo" v-if="basicInfo.SAppBankBaseInfo.Logo" :src="basicInfo.SAppBankBaseInfo.Logo" />
                  <span class="bankName">{{ basicInfo.SAppBankBaseInfo.BankName || '无' }}</span>
                  <div class="edit-btn" @click="modifyBankCard">
                    修改
                    <div v-if="bankIsLackInfo" class="modify">补充身份证</div>
                  </div>
                </div>
                <p class="card-number"><span>****&nbsp;&nbsp;****&nbsp;&nbsp;****</span>&nbsp;&nbsp;{{ basicInfo.SAppBankBaseInfo.BankCardNumber | fliterCardNumber }}</p>
              </div>
              <!-- add -->
              <div class="add-card" v-else @click="addBankCard">
                <i class="iconfont icon-close"></i>
                <span>添加银行卡</span>
              </div>
            </div>
          </div>
          <!-- 微信提现关闭状态 -->
          <div class="radio-type-item" @click="showWxTALimitDialog" v-if="basicInfo.IsWechatAvailable && basicInfo.IsWxTALimit">
            <label class="radio-select-lable">
              <input type="radio" class="radio-input" name="withdrawRadio" disabled />
              <span class="radio-core disabled"></span>
            </label>
            <div class="radio-item-detail">
              <i class="iconfont icon-weixin1 wx"></i>
              <div>微信提现</div>
              <span class="iconfont icon-wenhao"></span>
            </div>
          </div>
          <!-- 支付宝提现关闭状态 -->
          <div class="radio-type-item" @click="showZFBTALimitDialog" v-if="!zfbWithdrawalStatus.isAlipayAvailable">
            <label class="radio-select-lable">
              <input type="radio" class="radio-input" name="withdrawRadio" disabled />
              <span class="radio-core disabled"></span>
            </label>
            <div class="radio-item-detail">
              <i class="iconfont icon-zhifubao zfb"></i>
              <div>支付宝提现</div>
              <span class="iconfont icon-wenhao"></span>
            </div>
          </div>
        </div>
        <button :class="{ default: withdrawType === 2 && bankCardIsError }" @click="withDrawSubmit">
          立即提现
        </button>
      </div>
    </div>
    <!-- 提现明细 -->
    <detaile-list :drop-tile="pickerSelectVal" :info-list="infoList" @listDropSelect="popupVisible = true" @loadMore="loadMore" @checkReason="checkReason"> </detaile-list>
    <mt-popup v-model="popupVisible" position="bottom">
      <div style="width: 100%">
        <div class="picker-btn">
          <span @click="popupVisible = false">取消</span>
          <span @click="popupSure">确定</span>
        </div>
        <mt-picker :slots="detailTypeSlots" @change="popupValuesChange"></mt-picker>
      </div>
    </mt-popup>
    <!-- no more -->
    <segement-Line v-if="!haveMore" line-text="没有更多明细了"> </segement-Line>
    <segement-Line v-else :is-load="true"> </segement-Line>
    <!-- 海报弹窗 -->
    <!-- 海报 -->
    <poster-dialog :image-url="youpPath + posterWithdrawImg" :is-show-poster="isShowPoster" @closePoster="closePoster" @entoPosterDetail="entoPosterDetail"> </poster-dialog>
    <error-dialog v-if="errDialogShow" :limit-count="dialogLimitCount" @close="errDialogShow = false"> </error-dialog>
    <!-- APP 引导用户关注公众号弹窗 -->
    <follow-popup :followPopupData="followPopupData" @close="followPopupData.isShow = false"></follow-popup>
    <!-- 核对支付宝提现信息弹窗 -->
    <van-dialog v-model="isShowZfbWithdrawalVerifyDialog" overlayClass="overlayClass" show-cancel-button confirmButtonColor="#0077ff" @confirm="fetchWithDraw">
      <div class="accountInfoBox">
        <div class="title">请核对提现信息</div>
        <div class="topPart">
          <div class="item">
            <div class="label">支付宝号：</div>
            <div class="content account">
              {{ $utils.stringModify(basicInfo.AlipayNo, 11) }}
            </div>
          </div>
          <div class="item">
            <div class="label">提现金额：</div>
            <div class="content">{{ basicInfo.Amount > basicInfo.AlipayMaxMoney ? basicInfo.AlipayMaxMoney : basicInfo.Amount }}元</div>
          </div>
        </div>
        <div class="tip">
          金额将提现至该支付宝账户中，如确认无误，请点击确定。有误则点击取消。
        </div>
      </div>
    </van-dialog>
    <!-- 核对银行卡提现信息弹窗 -->
    <van-dialog v-model="isShowBankWithdrawalVerifyDialog" overlayClass="overlayClass" show-cancel-button @confirm="fetchWithDraw">
      <div class="accountInfoBox" v-if="bankCardConfirmPoundageInfo">
        <div class="title">提示</div>
        <div class="topTip">请核实下方金额&手续费，是否确认提现？</div>
        <div class="subList">
          <div class="item">
            <div class="subLeft">
              <div class="dot"></div>
              <span>提现金额:</span>
            </div>
            <div class="subRight">￥{{ bankCardConfirmPoundageInfo.Amount.toFixed(2) }}</div>
          </div>
          <div class="item">
            <div class="subLeft">
              <div class="dot"></div>
              <span>手续费:</span>
            </div>
            <div class="subRight">￥{{ bankCardConfirmPoundageInfo.Poundage.toFixed(2) }}</div>
          </div>
          <div class="item active">
            <div class="subLeft">
              <div class="dot"></div>
              <span>实际到账金额:</span>
            </div>
            <div class="subRight">￥{{ bankCardConfirmPoundageInfo.AmountToBuyer.toFixed(2) }}</div>
          </div>
        </div>
      </div>
    </van-dialog>
    <!-- 扣除待扣金额动作画板 -->
    <van-action-sheet v-model="showPayMode" :actions="actions" cancel-text="取消" close-on-click-action description="请选择支付方式" @select="selectPayMode" />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { IMG_BASE_URL } from '@/config'
import { Indicator, MessageBox } from 'mint-ui'
import SegementLine from '@/components/puppetComponent/SegementLine'
import PosterDialog from '@/components/puppetComponent/PosterDialog'
import ErrorDialog from './children/ErrorDialog'
import DetaileList from './children/DetaileList'
import WithdrawDetail from './children/WithdrawDetail'
import { ActionSheet } from 'vant'
import { WeChatTransfer, BankCardTransfer, AlipayTransfer, SAppAddDeductAmount, QueryWxPayTransactionStatus } from '@/api/wechatTransfer'
import FollowPopup from './children/FollowPopup'
import { TransferAccountsBasicInfoGet, TransferAccountInfoListGet, BankCardConfirmPoundage } from '@/api/my'
import './children/iconfont'
import baseUtil from '@/utils/base'

export default {
  data() {
    return {
      haveMore: true,
      scrollDisabled: false,
      basicInfo: null,
      isFetched: false,
      infoList: [],
      currentPage: 1,
      page: 1,
      pageCount: 1,
      withdrawDetailType: 0, // 提现明细筛选类型
      // 会员
      youpPath: IMG_BASE_URL,
      isShowPoster: false,
      posterWithdrawImg: '/upaiyun/Sys/20220505/4703220385174729481.png',
      dialogLimitCount: '',
      errDialogShow: false,
      withdrawType: null, // 提现类型
      bankCardIsError: false, // 银行卡是否异常
      popupVisible: false,
      pickerSelectVal: '全部',
      detailTypeSlots: [
        {
          values: ['全部', '微信', '支付宝', '银行卡'],
          textAlign: 'center'
        }
      ],
      followPopupData: {
        isShow: false
      },
      isShowZfbWithdrawalVerifyDialog: false, // 是否展示核对支付宝提现信息弹窗
      isShowBankWithdrawalVerifyDialog: false, // 是否展示核对银行卡提现信息弹窗
      bankCardConfirmPoundageInfo: null, // 银行卡确认手续费信息
      expectChoseWithdrawType: '',
      showPayMode: false, // 是否展示扣除待扣金额动作画板
      actions: [
        { name: '余额支付', PayMethod: 0 },
        { name: '微信支付', PayMethod: 1 }
      ], // 扣除待扣金额方式数组
      prepayId: '' // 支付记录
    }
  },
  components: {
    SegementLine,
    PosterDialog,
    ErrorDialog,
    DetaileList,
    WithdrawDetail,
    FollowPopup,
    'van-action-sheet': ActionSheet
  },
  created() {
    this.expectChoseWithdrawType = this.$route.params.expectChoseWithdrawType
  },
  mounted() {
    this.fetchAllData()
  },
  methods: {
    ...mapMutations(['SET_BANK_INFO']),
    fetchData() {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      this.bankCardIsError = false
      TransferAccountsBasicInfoGet()
        .then((res) => {
          if (res.SAppBankBaseInfo && res.SAppBankBaseInfo.BankCardNumber) {
            res.SAppBankBaseInfo.BankCardNumber = '********' + res.SAppBankBaseInfo.BankCardNumber.substr(-4)
          }
          this.isFetched = true
          this.basicInfo = res
          // 提现方式配置数组
          let tempArr = [this.basicInfo.IsWechatAvailable, this.basicInfo.IsAlipayAvailable, this.basicInfo.SAppBankBaseInfo]
          let wayNum = 0
          tempArr.filter((val) => {
            if (val) wayNum++
          })
          if (wayNum === 1) {
            // 若提现方式仅存在一项，则默认选中展现的那一项
            this.withdrawType = tempArr.findIndex((val) => {
              return val
            })
          } else {
            // 银行卡异常，默认选中银行卡
            let bankInfo = this.basicInfo.SAppBankBaseInfo
            // 期望选中银行卡
            if (this.expectChoseWithdrawType === 2 && this.basicInfo.IsBankAvailable) {
              this.withdrawType = this.expectChoseWithdrawType
            }
            // 期望选中支付宝
            if (this.expectChoseWithdrawType === 1 && this.basicInfo.IsAlipayAvailable) {
              this.withdrawType = this.expectChoseWithdrawType
            }
            if (bankInfo && bankInfo.Status === 1) {
              this.withdrawType = 2
              this.bankCardIsError = true
            }
          }
          Indicator.close()
        })
        .catch((res) => {
          this.isFetched = true
          Indicator.close()
          if (res.ErrMsg) {
            this.$toast(res.ErrMsg)
          }
        })
    },
    fetchListData() {
      let params = {
        withdrawDetailType: this.withdrawDetailType,
        page: this.currentPage
      }
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      this.scrollDisabled = true
      TransferAccountInfoListGet(params)
        .then((res) => {
          Indicator.close()
          this.infoList = [...this.infoList, ...res.DataList]
          this.page = res.PaginationViewModel.Page
          this.pageCount = res.PaginationViewModel.PageCount
          if (res.PaginationViewModel.Page >= res.PaginationViewModel.PageCount) {
            this.haveMore = false
          }
          this.scrollDisabled = false
        })
        .catch((res) => {
          this.haveMore = false
          Indicator.close()
          if (res.ErrMsg) {
            this.$toast(res.ErrMsg)
          }
        })
    },
    fetchAllData() {
      this.infoList = []
      this.currentPage = 1
      this.fetchData()
      this.fetchListData()
    },
    radioItemClick(type) {
      this.withdrawType = type
    },
    addBankCard() {
      this.SET_BANK_INFO(null)
      this.$router.push('bindCard')
    },
    modifyBankCard() {
      this.SET_BANK_INFO(this.basicInfo.SAppBankBaseInfo)
      this.$router.push({
        name: 'bindCard'
      })
    },
    // 提现前验证
    validateWithDraw(cb) {
      let { basicInfo } = this
      if (!this.isFetched) return false
      // 优先判断接口1回传的身份证号码是否为空，若为空，则给出弹窗提示
      if (this.withdrawType === 2 && this.bankIsLackInfo) {
        this.bankIsLackInfoHandler()
        return false
      }
      if (basicInfo.Amount === undefined || basicInfo.Amount <= 0) {
        this.$toast('已无账户余额可提现')
        return false
      }
      if (this.withdrawType === null) {
        this.$toast('请先选择提现方式')
        return false
      }
      if (this.withdrawType === 0 && !basicInfo.IsWechatAvailable) {
        this.$toast('当前微信提现暂时无法使用，请使用其他方式提现')
        return false
      }
      if (this.withdrawType === 0 && basicInfo.Amount < basicInfo.MinMoney) {
        this.$toast(`最低提现金额为${basicInfo.MinMoney}元`)
        return false
      }
      if (this.withdrawType === 0 && basicInfo.Amount > basicInfo.MaxMoney) {
        // 现金额大于【微信提现最大上限配置】
        MessageBox({
          title: '提示',
          message: `最大提现金额为【${basicInfo.MaxMoney}】，本次将仅提现【${basicInfo.MaxMoney}】元，是否确认？`,
          showCancelButton: true,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          confirmButtonText: '确认',
          confirmButtonClass: 't_f23030'
        }).then((action) => {
          if (action === 'confirm' && cb) {
            cb()
          }
        })
        return false
      }
      if (this.withdrawType === 2 && (this.bankCardIsError || !basicInfo.IsBankAdd)) {
        this.$toast(`请先${basicInfo.IsBankAdd ? '修改' : '添加'}银行卡`)
        return false
      }
      if (this.withdrawType === 2 && basicInfo.Amount < basicInfo.BankMinMoney) {
        this.$toast(`最低提现金额为${basicInfo.BankMinMoney}元`)
        return false
      }
      if (this.withdrawType === 2 && basicInfo.Amount > basicInfo.BankMaxMoney) {
        MessageBox({
          title: '提示',
          message: `最大提现金额为【${basicInfo.BankMaxMoney}】，本次将仅提现【${basicInfo.BankMaxMoney}】元，是否确认？`,
          showCancelButton: true,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          confirmButtonText: '确认',
          confirmButtonClass: 't_f23030'
        }).then((action) => {
          if (action === 'confirm') {
            this.getBankCardConfirmPoundage()
          }
        })
        return false
      }
      // 支付宝提现校验 start
      if (this.withdrawType === 1 && !basicInfo.IsBindAlipay) {
        this.$toast('请先绑定支付宝账号')
        return false
      }
      if (this.withdrawType === 1 && basicInfo.Amount > basicInfo.AlipayMaxMoney) {
        MessageBox({
          title: '提示',
          message: `最大提现金额为【${basicInfo.AlipayMaxMoney}】，本次将仅提现【${basicInfo.AlipayMaxMoney}】元，是否确认？`,
          showCancelButton: true,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          confirmButtonText: '确认',
          confirmButtonClass: 't_f23030'
        }).then((action) => {
          if (action === 'confirm') {
            this.isShowZfbWithdrawalVerifyDialog = true
          }
        })
        return false
      }
      if (this.withdrawType === 1 && basicInfo.Amount < basicInfo.AlipayMinMoney) {
        this.$toast(`最低提现金额为${basicInfo.AlipayMinMoney}元`)
        return false
      }
      // 支付宝提现校验 end
      if (basicInfo.DayCountRemain <= 0) {
        this.$toast('已无剩余提现次数')
        return false
      }
      return true
    },
    // 银行卡信息缺漏
    bankIsLackInfoHandler() {
      MessageBox({
        title: '提示',
        message: `目前银行卡提现需使用身份证号码，请点击去补充按钮添加后再进行提现`,
        showCancelButton: true,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        confirmButtonText: '去补充',
        cancelButtonText: '我知道了',
        confirmButtonClass: 't_f23030'
      }).then((action) => {
        if (action === 'confirm') {
          this.modifyBankCard()
        } else {
          console.log('我知道了')
        }
      })
    },
    // 立即提现
    withDrawSubmit() {
      let isPass = this.validateWithDraw(this.fetchWithDraw)
      if (!isPass) return
      if (this.withdrawType === 1) {
        this.isShowZfbWithdrawalVerifyDialog = true
        return
      } else if (this.withdrawType === 2) {
        this.getBankCardConfirmPoundage()
        return
      }
      MessageBox({
        title: '提示',
        message: `是否确认把全部余额提现至${this.withdrawType === 2 ? '银行卡' : '微信'}？`,
        showCancelButton: true,
        confirmButtonClass: 't_f23030'
      }).then((action) => {
        if (action === 'confirm') {
          // 提现
          this.fetchWithDraw()
        }
      })
    },
    // 提现请求
    fetchWithDraw() {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      let feathMethod = ''
      switch (this.withdrawType) {
        case 0:
          feathMethod = WeChatTransfer
          break
        case 1:
          feathMethod = AlipayTransfer
          break
        default:
          feathMethod = BankCardTransfer
          break
      }
      feathMethod()
        .then((res) => {
          Indicator.close()
          if (this.withdrawType === 2 && res.Msg) {
            // 银行卡提现成功
            MessageBox({
              title: '提示',
              message: `银行卡提现申请已提交，提现将在【${res.Msg}】前完成`,
              showCancelButton: false,
              confirmButtonText: '我知道了',
              confirmButtonClass: 't_f23030',
              closeOnClickModal: false
            }).then((action) => {
              if (action === 'confirm') {
                this.fetchAllData()
                this.showPoster(res.Data.isFirstWithDraw)
              }
            })
          } else {
            this.$toast({
              message: '提现成功',
              iconClass: 'mint-toast-icon mintui mintui-success'
            })
            setTimeout(this.fetchAllData, 3000)
            this.showPoster(res.Data.isFirstWithDraw)
          }
        })
        .catch((res) => {
          Indicator.close()
          if (res.ErrMsg === '存在待扣金额未扣除，请联系客服处理') {
            MessageBox({
              title: '提示',
              message: res.ErrMsg,
              showCancelButton: true,
              confirmButtonText: '联系客服',
              cancelButtonText: '查看待扣金额',
              confirmButtonClass: 't_f23030',
              cancelButtonClass: 't_blue'
            }).then((action) => {
              if (action === 'confirm') {
                this.$router.push({
                  name: 'posterDetail',
                  query: {
                    isContact: 1
                  }
                })
              } else {
                this.$router.push({
                  name: 'waitingForPayDetail'
                })
              }
            })
          } else if (res.ErrMsg === '请关注公众号后再进行提现' && this.getIsApp) {
            this.followPopupData.isShow = true
          } else if (res.ErrMsg === '目前银行卡提现需使用身份证号码，请点击去补充按钮添加后再进行提现') {
            this.bankIsLackInfoHandler()
          } else {
            if (res.Data && res.Data.hasOwnProperty('limitCount')) {
              this.dialogLimitCount = res.Data.limitCount
              if (this.dialogLimitCount) this.errDialogShow = true
              return
            }
            if (res.ErrMsg) {
              this.$toast(res.ErrMsg)
            }
            setTimeout(this.fetchAllData, 3000)
          }
        })
    },
    checkReason(FailRemark) {
      MessageBox({
        title: '提示',
        message: FailRemark + `<br>如有疑问，请联系客服进行处理`,
        showCancelButton: false,
        confirmButtonText: '我知道了',
        confirmButtonClass: 't_f23030'
      }).then((action) => {})
    },
    showPoster(isFirstWithDraw) {
      if (isFirstWithDraw) {
        this.isShowPoster = true
      } else {
        this.isShowPoster = false
      }
    },
    popupSure() {
      this.popupVisible = false
      this.infoList = []
      this.currentPage = 1
      this.fetchListData()
    },
    popupValuesChange(picker, values) {
      let val = values[0]
      this.pickerSelectVal = val
      if (val === '全部') {
        this.withdrawDetailType = 0
      } else if (val === '微信') {
        this.withdrawDetailType = 1
      } else if (val === '银行卡') {
        this.withdrawDetailType = 2
      } else if (val === '支付宝') {
        this.withdrawDetailType = 3
      }
    },
    // 查看明细
    checkDetail() {
      this.$router.push('balance')
    },
    // 关闭海报
    closePoster() {
      this.isShowPoster = false
    },
    entoPosterDetail(flag) {
      this.$router.push({
        name: 'zeroBuyMain'
      })
    },
    loadMore() {
      let { page, pageCount } = this
      if (page >= pageCount) {
        this.haveMore = false
        return
      }
      this.currentPage += 1
      this.haveMore = true
      this.fetchListData()
    },
    modifyZFB(type = 0) {
      let query = null
      if (type === 1) {
        query = {
          AlipayNo: this.basicInfo.AlipayNo,
          AlipayName: this.basicInfo.AlipayName
        }
      }
      this.$router.push({
        name: 'bindZFB',
        query: query
      })
    },
    showWxTALimitDialog() {
      this.$dialog
        .alert({
          title: '提示',
          message: '当前微信提现已关闭，请使用其他提现方式'
        })
        .then(() => {
          // on close
        })
    },
    showZFBTALimitDialog() {
      this.$dialog
        .alert({
          title: '提示',
          message: this.zfbWithdrawalStatus.alertText
        })
        .then(() => {
          // on close
        })
    },
    // 获取银行卡确认手续费信息
    getBankCardConfirmPoundage() {
      BankCardConfirmPoundage()
        .then((res) => {
          this.bankCardConfirmPoundageInfo = res
          this.isShowBankWithdrawalVerifyDialog = true
        })
        .catch((res) => {
          if (res.ErrMsg) {
            this.$toast(res.ErrMsg)
          }
        })
    },
    // 查询支付状态接口
    queryWxPayTransactionStatus() {
      return new Promise((resolve, reject) => {
        this.$toast.loading({
          message: '支付状态同步中...',
          forbidClick: true
        })
        QueryWxPayTransactionStatus({ prepayId: this.prepayId })
          .then((res) => {
            this.$toast.clear()
            switch (res.Data.TransactionStatus) {
              case 1:
                // 支付成功
                MessageBox({
                  title: '提示',
                  message: '待扣金额已支付成功，感谢您的理解与配合！',
                  showCancelButton: false,
                  confirmButtonText: '我知道了',
                  confirmButtonClass: 't_f23030'
                }).then((action) => {
                  if (action === 'confirm') {
                    resolve()
                  }
                })
                break
              default:
                // 其他状态
                MessageBox({
                  title: '提示',
                  message: '未查询到支付成功，如已完成支付，请耐心等待1-3分钟后再次刷新，如待扣金额依然存在，请联系客服',
                  showCancelButton: true,
                  confirmButtonText: '我知道了',
                  cancelButtonText: '联系客服',
                  confirmButtonClass: 't_f23030'
                }).then((action) => {
                  if (action === 'cancel') {
                    this.$router.push({
                      name: 'posterDetail',
                      query: {
                        isContact: 1
                      }
                    })
                  } else {
                    resolve()
                  }
                })
                break
            }
          })
          .catch((err) => {
            // 其他状态
            MessageBox({
              title: '提示',
              message: '未查询到支付成功，如已完成支付，请耐心等待1-3分钟后再次刷新，如待扣金额依然存在，请联系客服',
              showCancelButton: true,
              confirmButtonText: '我知道了',
              cancelButtonText: '联系客服',
              confirmButtonClass: 't_f23030'
            }).then((action) => {
              if (action === 'cancel') {
                this.$router.push({
                  name: 'posterDetail',
                  query: {
                    isContact: 1
                  }
                })
              } else {
                resolve()
              }
            })
          })
      })
    },
    // 选择代扣金额支付方式
    selectPayMode(item) {
      this.showPayMode = false
      if (item.PayMethod === 0 && Number(this.basicInfo.Amount) < Number(this.basicInfo.WaitDeductAmount)) {
        // 选择【余额支付】时，优先判断用户余额是否大于等于待扣金额
        this.$toast('当前余额不足，请选择微信支付')
        return
      }
      let params = {
        PayMethod: item.PayMethod,
        Amount: this.basicInfo.WaitDeductAmount
      }
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      SAppAddDeductAmount(params)
        .then(async (res) => {
          if (item.PayMethod === 1) {
            this.prepayId = res.Data.package.split('=')[1]
            await baseUtil.chooseWXPay(res.Data)
            this.$toast.clear()
            await this.queryWxPayTransactionStatus()
            this.fetchAllData()
          } else {
            this.$toast.clear()
            MessageBox({
              title: '提示',
              message: '待扣金额已支付成功，感谢您的理解与配合！',
              showCancelButton: false,
              confirmButtonText: '我知道了',
              confirmButtonClass: 't_f23030'
            }).then((action) => {
              if (action === 'confirm') {
                this.fetchAllData()
              }
            })
          }
        })
        .catch((err) => {
          this.$toast.clear()
          if (err.ErrMsg) this.$toast(err.ErrMsg)
        })
    }
  },
  computed: {
    ...mapGetters(['getIsApp']),
    // 支付宝提现状态
    zfbWithdrawalStatus() {
      let isAlipayFinallyAvailable = true // 最终是否允许支付宝提现
      let alertText = '' // 最终无法提现文案
      let IsWxTALimit = this.basicInfo.IsWxTALimit // 是否降权用户
      let IsAlipayAvailable = this.basicInfo.IsAlipayAvailable // 允许支付宝提现IsAlipayAvailable
      let IsDownRightAlipayWithdraw = this.basicInfo.IsDownRightAlipayWithdraw // 降权用户是否允许支付宝提现
      let AliDownRightMsg = this.basicInfo.AliDownRightMsg // 降权用户无法提现文案
      let AliNormalMsg = this.basicInfo.AliNormalMsg // 正常用户支付宝无法提现文案
      // 优先判断用户是否存在降权用户标识，判定为正常用户or降权用户
      if (IsWxTALimit) {
        // 如为降权用户，则根据降权用户是否允许支付宝提现配置，如不允许给出返回的降权用户无法提现文案配置
        if (!IsDownRightAlipayWithdraw) {
          isAlipayFinallyAvailable = false
          alertText = AliDownRightMsg
        }
      } else {
        // 如为正常用户，则根据是否允许支付宝提现，如不允许则直接返回正常用户支付宝无法提现文案配置
        if (!IsAlipayAvailable) {
          isAlipayFinallyAvailable = false
          alertText = AliNormalMsg
        }
      }
      return {
        isAlipayAvailable: isAlipayFinallyAvailable,
        alertText: alertText
      }
    },
    // 支付宝提现状态
    bankWithdrawalStatus() {
      let isBankAvailable = this.basicInfo.IsBankAvailable || (this.basicInfo.IsOpenBankDownRight && this.basicInfo.IsWxTALimit)
      return isBankAvailable
    },
    // 银行卡是否缺少信息
    bankIsLackInfo() {
      if (this.basicInfo && this.basicInfo.SAppBankBaseInfo) {
        let { BankCardNumber, IdentityCardNumber } = this.basicInfo.SAppBankBaseInfo
        // 若接口1回传的用户的银行卡号码不为空且身份证号码为空，则在银行卡信息展现区域中
        return BankCardNumber && (IdentityCardNumber === '' || IdentityCardNumber === null)
      } else {
        return false
      }
    }
  },
  filters: {
    fliterCardNumber(val) {
      if (!val) return '----'
      return val.substr(-4)
    },
    formatName(str) {
      return str.substr(0, 1) + new Array(str.length).join('*')
    }
  }
}
</script>

<style scoped lang="scss">
$base_width: 375;
@function vw($px) {
  @return ($px / $base_width) * 100vw;
}
.main {
  position: relative;
  font-size: 13px;
  background: #f5f5f5;
  min-height: 100vh;
  overflow: hidden;
}
.withdraw {
  overflow: hidden;
}
/* 提现类型 */
.withdraw-type-box {
  background: #fff;
  padding: 0 3% 4%;
}
.withdraw-type-box .title {
  height: 40px;
  line-height: 40px;
  font-size: 15px;
}
.withdraw-type-box button {
  display: block;
  width: 95%;
  height: 11.5vw;
  line-height: 11.5vw;
  font-size: 15px;
  background: #fff;
  border: 1px solid #353434;
  border-radius: 5px;
  margin: 7vw auto 0 auto;
}
.withdraw-type-box button:active {
  background: #f5f5f5;
}
.withdraw-type-box button.default {
  border-color: transparent;
  background: #e8e8e8;
  color: #686868;
}
.withdraw-type-error {
  height: 42px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #ff4d4f;
  background: #fff1f0;
  margin: 0 10px;
  padding: 0 10px;
  box-sizing: border-box;
  border-radius: 3px;
  animation-fill-mode: backwards;
  animation: opacityAnim 0.2s ease-in;
}
.withdraw-type-error .iconfont {
  margin-right: 5px;
  vertical-align: baseline;
}
.radio-type-group {
  margin: 0 10px;
}
.radio-type-item {
  display: flex;
  align-items: center;
  min-height: 16vw;
  .bindZFBInfo {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    width: 100%;
    height: 62px;
    padding: 9px;
    background-color: #eeeeee;
    margin: 0 auto;
    border-radius: 12px;
    .leftPart {
      display: flex;
      align-items: center;
      .logo {
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 36px;
        height: 36px;
        background-color: rgba(245, 245, 245, 100);
        // border-radius: 50%;
        margin-right: 7px;
        // overflow: hidden;
        .iconfont {
          font-size: 36px;
          color: rgba(74, 134, 246, 100);
        }
      }
      .accountInfo {
        display: flex;
        align-items: center;
        color: rgba(74, 134, 246, 100);
        font-size: 15px;
        .account {
          margin-right: 4px;
        }
      }
    }
    .modifyBtn {
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 60px;
      height: 22px;
      border-radius: 11px;
      font-size: 14px;
      color: rgba(74, 134, 246, 100);
      border: 1px solid rgba(74, 134, 246, 100);
    }
  }
}
/* radio */
.radio-select-lable {
  width: 10vw;
  height: 100%;
}
.radio-select-lable .radio-input {
  display: none;
}
.radio-select-lable .radio-core {
  display: inline-block;
  background-color: #fff;
  border-radius: 50%;
  border: 1px solid #ccc;
  position: relative;
  width: 20px;
  height: 20px;
  vertical-align: middle;
  box-sizing: border-box;
  &.disabled {
    border: none;
    background-color: #dedede;
  }
}
.radio-core::after {
  content: ' ';
  border: 1px solid #fff;
  border-left: 0;
  border-top: 0;
  top: 4px;
  left: 7px;
  position: absolute;
  width: 4px;
  height: 8px;
  transform: rotate(45deg) scale(0.2);
  transition: transform 0.2s ease-out;
}
.radio-input:checked + .radio-core::after {
  transform: rotate(45deg) scale(1);
}
.radio-input:checked + .radio-core {
  background-color: #0076ff;
  border-color: #0076ff;
}
.radio-item-detail {
  flex-grow: 1;
  display: flex;
  align-items: center;
  padding-left: 5px;
  // box-sizing: border-box;
  min-height: 16vw;
  border-bottom: 1px solid #eee;
  height: 100%;
  font-size: 15px;
}
.radio-item-detail.noborder {
  border-bottom: none;
}
.radio-item-detail .iconfont {
  position: relative;
  top: 1px;
  font-size: 25px;
  margin-right: 10px;
}
.radio-item-detail .icon-wenhao {
  font-size: 14px;
  margin: 0 0 0 10px;
}
.radio-item-detail .wx {
  color: #259b24;
}
.radio-item-detail .card {
  color: #457ee8;
}
.radio-item-detail .zfb {
  color: rgba(74, 134, 246, 100);
}
/* card */
.radio-type-group .card-item {
  display: block;
}
.card-item .card-radio-box {
  display: flex;
  align-items: center;
  width: 100%;
}
.card-item .card-detail-box {
  position: relative;
  margin: 0 0 2.5vw;
  animation-fill-mode: backwards;
  animation: opacityAnim 0.2s ease-in;
}
.card-detail-box::after {
  content: '';
  position: absolute;
  bottom: -3.5vw;
  right: 0;
  width: calc(100% - 10vw);
  height: 1px;
  background: #eee;
}
.card-detail-box .card-info {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 26vw;
  color: #fff;
  border-radius: 5px;
  box-sizing: border-box;
  padding: 3vw 4.5vw 2vw;
  background: #457ee8;
  background: url('http://youp-read.leqilucky.com/upaiyun/Sys/20200729/5358596740526150669.png') no-repeat;
  background-size: 100% auto;
  background-position: center center;
}
.card-info .c-info {
  display: flex;
  align-items: center;
}
.card-info .logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #fff;
  margin-right: 10px;
  text-align: center;
  line-height: 36px;
}
.card-info .logo img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.svg-icon {
  width: 28px;
  height: 28px;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.card-info .edit-btn {
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 66px;
  height: 24px;
  text-align: center;
  border-radius: 15px;
  border: 1px solid #fff;
  position: relative;
}
.edit-btn {
  .modify {
    position: absolute;
    background-color: #ff0000;
    color: #fff;
    transform: translateY(-150%) translateX(40%);
    font-size: 12px;
    padding: 0 6px;
    white-space: nowrap;
    border-radius: 10px;
    &::before {
      position: absolute;
      content: '';
      bottom: 0;
      transform: translateY(100%);
      left: 6px;
      width: 0;
      height: 0;
      border-top: 6px solid #ff0000;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
    }
  }
}
.card-info .bankName {
  font-size: 16px;
}
.card-info .card-number {
  font-size: 20px;
  text-align: right;
}
.card-number span {
  vertical-align: sub;
}
.card-detail-box .add-card {
  display: flex;
  align-items: center;
  margin: 1vw 0 2.5vw;
  height: 60px;
  border-radius: 5px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid #f5f5f5;
  padding: 0 15px;
  box-sizing: border-box;
  font-size: 16px;
  cursor: pointer;
}
.card-detail-box .add-card .iconfont {
  transform: rotateZ(-45deg);
  margin-right: 10px;
  font-size: 15px;
  font-weight: 800;
}
/* picker */
.main .mint-popup-bottom {
  width: 100%;
}
.picker-btn {
  width: 100%;
  height: 40px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0 10px;
  font-size: 16px;
  color: #457ee8;
}
.accountInfoBox {
  width: 100%;
  box-sizing: border-box;
  padding: 26px 20px;
  color: #6c6c6c;
  .title {
    color: #1d1d1d;
    font-size: 18px;
    text-align: center;
    margin-bottom: 20px;
    font-weight: 500;
  }
  .topPart {
    .item {
      display: flex;
      align-items: center;
      .account {
        color: #ff2d3c;
        font-weight: 700;
      }
    }
  }
  .tip {
    margin-top: 20px;
  }
  .subList {
    .item {
      display: flex;
      align-items: center;
      margin-bottom: 4px;
      &:last-child {
        margin-bottom: 0;
      }
      &.active {
        .subLeft {
          .dot {
            background-color: #f22c6c;
          }
        }
        .subRight {
          color: #f22c6c;
        }
      }
      .subLeft {
        display: flex;
        align-items: center;
        width: 140px;
        .dot {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          margin-right: 8px;
          background-color: #9a9a9a;
        }
      }
    }
  }
  .topTip {
    margin-bottom: 20px;
  }
}
.fs_13 {
  font-size: 13px;
}
// 增加展现【待扣金额】模块
.waitingForPayModel {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin: 3% 3%;
  background-color: #fff;
  padding: 3% 4%;
  border-radius: 10px;
  height: vw(100);
  .infoPart {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    width: 100%;
    border-bottom: 1px solid #ededed;
    box-sizing: border-box;
    padding-bottom: 10px;
    .tip {
      font-size: 16px;
    }
    .price {
      font-size: 24px;
      font-weight: 700;
      .symbol {
        font-size: 12px;
      }
    }
  }
  .controlPart {
    display: flex;
    margin-top: 3%;
    .btn {
      height: 28px;
      line-height: 28px;
      padding: 0 10px;
      color: #1f1f1f;
      border: 1px solid #1f1f1f;
      border-radius: 4px;
      margin-right: 10px;
      &:last-child {
        margin-right: 0;
      }
      &.mainBtn {
        color: #4fa8ff;
        border: 1px solid #4fa8ff;
      }
    }
  }
}
</style>
